import { render } from "./SalesOverTime.vue?vue&type=template&id=a2a38e60&ts=true"
import script from "./SalesOverTime.vue?vue&type=script&lang=ts"
export * from "./SalesOverTime.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__